import React, { FunctionComponent } from "react";
import { ComponentProps } from "../components/component-props";
import { Demo } from "../components/demo";

const breadcrumbDemo = { code:
`<Breadcrumb
    items={[
        { title: "Home", level: 1, link: "" },
        { title: "English", level: 2, link: "" },
        { title: "Blogs", level: 3, link: "" },
        { title: "How to mock a killing bird", level: 4, link: "", active: true }
    ]}
/>`
};

export const BreadcrumbDemo: FunctionComponent = () => {
    return (
        <Demo demo={breadcrumbDemo}>
            <ComponentProps componentName="Breadcrumb" />
        </Demo>
    );
};
